//windcave helpers to be imported into checkout modal or wherever else they are needed
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      stationId: "3425510089",
      currentTxnRef: null,
      currentAmount: 0,
      cancelling: false,
    };
  },

  mounted() {},

  computed: {
    ...mapGetters(["siteSettings", "windcaveResponse"]),
  },

  watch: {
    windcaveResponse(newVal) {
      if (newVal) {
        this.decodeResponse(newVal);
      }
    },
  },

  methods: {
    generateSCR() {
      const scrDoc = document.implementation.createDocument(null, "Scr");
      scrDoc.documentElement.setAttribute("action", "doScrHIT");
      scrDoc.documentElement.setAttribute("user", process.env.VUE_APP_HIT_ID);
      scrDoc.documentElement.setAttribute("key", process.env.VUE_APP_HIT_KEY);
      return scrDoc;
    },

    scrToString(scr) {
      return new XMLSerializer().serializeToString(scr);
    },

    genEl(scr, key, value) {
      const el = scr.createElement(key);
      el.textContent = value;
      return el;
    },

    initTransaction(amount) {
      this.cancelling = false;
      this.eftposBusy = true;
      this.currentTxnRef = uuidv4();
      this.currentAmount = parseFloat(amount);
      const scr = this.generateSCR();
      const amountEl = this.genEl(scr, "Amount", this.currentAmount);
      const stationId = this.genEl(scr, "Station", this.stationId);
      const currency = this.genEl(scr, "Cur", "NZD");
      const txnType = this.genEl(scr, "TxnType", "Purchase");
      const txnRef = this.genEl(scr, "TxnRef", this.currentTxnRef);
      const deviceId = this.genEl(scr, "DeviceId", localStorage.getItem("company") + "-" + localStorage.getItem("site") + "-" + localStorage.getItem("station"));
      const vendorId = this.genEl(scr, "VendorId", "BeamyPOS");
      const posName = this.genEl(scr, "PosName", "Beamy_dev");
      scr.documentElement.appendChild(amountEl);
      scr.documentElement.appendChild(stationId);
      scr.documentElement.appendChild(currency);
      scr.documentElement.appendChild(txnType);
      scr.documentElement.appendChild(txnRef);
      scr.documentElement.appendChild(deviceId);
      scr.documentElement.appendChild(vendorId);
      scr.documentElement.appendChild(posName);
      return this.scrToString(scr);
    },

    cancelWindcaveTransaction() {
      this.cancelling = true;
      const scr = this.generateSCR();
      const stationId = this.genEl(scr, "Station", this.stationId);
      const txnType = this.genEl(scr, "TxnType", "UI");
      const txnRef = this.genEl(scr, "TxnRef", this.currentTxnRef);
      const UiType = this.genEl(scr, "UiType", "Bn");
      const val = this.genEl(scr, "Val", "CANCEL");
      const name = this.genEl(scr, "Name", "B2");
      scr.documentElement.appendChild(stationId);
      scr.documentElement.appendChild(txnType);
      scr.documentElement.appendChild(txnRef);
      scr.documentElement.appendChild(UiType);
      scr.documentElement.appendChild(val);
      scr.documentElement.appendChild(name);
      const scrString = this.scrToString(scr);
      this.postTransaction(scrString);
      this.eftposBusy = false;
    },

    acceptWindcaveSig() {
      const scr = this.generateSCR();
      const stationId = this.genEl(scr, "Station", this.stationId);
      const txnType = this.genEl(scr, "TxnType", "UI");
      const txnRef = this.genEl(scr, "TxnRef", this.currentTxnRef);
      const UiType = this.genEl(scr, "UiType", "Bn");
      const val = this.genEl(scr, "Val", "YES");
      const name = this.genEl(scr, "Name", "B1");
      scr.documentElement.appendChild(stationId);
      scr.documentElement.appendChild(txnType);
      scr.documentElement.appendChild(txnRef);
      scr.documentElement.appendChild(UiType);
      scr.documentElement.appendChild(val);
      scr.documentElement.appendChild(name);
      const scrString = this.scrToString(scr);
      this.postTransaction(scrString);
    },

    declineWindcaveSig() {
      const scr = this.generateSCR();
      const stationId = this.genEl(scr, "Station", this.stationId);
      const txnType = this.genEl(scr, "TxnType", "UI");
      const txnRef = this.genEl(scr, "TxnRef", this.currentTxnRef);
      const UiType = this.genEl(scr, "UiType", "Bn");
      const val = this.genEl(scr, "Val", "NO");
      const name = this.genEl(scr, "Name", "B2");
      scr.documentElement.appendChild(stationId);
      scr.documentElement.appendChild(txnType);
      scr.documentElement.appendChild(txnRef);
      scr.documentElement.appendChild(UiType);
      scr.documentElement.appendChild(val);
      scr.documentElement.appendChild(name);
      const scrString = this.scrToString(scr);
      this.postTransaction(scrString);
      this.cancelling = true;
      this.eftposBusy = false;
    },

    decodeResponse(response) {
      console.log("Decoding response: ", response);
      if (this.cancelling) {
        this.cancelling = false;
        return;
      }
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(response.response, "application/xml");

      if (xmlDoc.getElementsByTagName("Success")[0] && xmlDoc.getElementsByTagName("Success")[0].textContent == "1") {
        this.transactionSuccess(xmlDoc, true);
        return;
      }
      const result = xmlDoc.getElementsByTagName("Complete")[0] ? xmlDoc.getElementsByTagName("Complete")[0].textContent : "0";
      console.log("Transaction result: ", result);
      if (result && result === "1") {
        this.transactionSuccess(xmlDoc);
      } else if (result === "0" && !this.cancelling) {
        if (xmlDoc.getElementsByTagName("DL1")[0].textContent == "SIGNATURE OK?") {
          this.eftposSigHandler();
        } else {
          this.checkTransactionStatus();
        }
      }
    },

    transactionSuccess(xmlDoc, success = false) {
      let approvalStatus = "1";
      if (!success) {
        let transResult = xmlDoc.getElementsByTagName("Result")[0];
        approvalStatus = transResult.getElementsByTagName("AP")[0].textContent;
      }
      if (approvalStatus === "0") {
        this.eftposBusy = false;
        this.$notify({
          text: "EFTPOS Transaction Declined",
          type: "error",
          duration: 5000,
        });
      } else {
        this.eftposBusy = false;
        this.addPayment({ type: "eftpos", value: this.currentAmount, id: this.currentTxnRef });
        this.completeTransaction();
      }
    },

    checkTransactionStatus() {
      const scr = this.generateSCR();
      const station = this.genEl(scr, "Station", this.stationId);
      const txnType = this.genEl(scr, "TxnType", "Status");
      const txnRefEl = this.genEl(scr, "TxnRef", this.currentTxnRef);
      scr.documentElement.appendChild(txnRefEl);
      scr.documentElement.appendChild(station);
      scr.documentElement.appendChild(txnType);
      const scrString = this.scrToString(scr);

      this.postTransaction(scrString);
    },

    postTransaction(scrString) {
      this.channel.push("windcave:post", { scr: scrString, url: process.env.VUE_APP_WINDCAVE_URL });
    },
  },
};
